import $ from 'jquery';
import _ from 'lodash-es';
import buttonsGetLine from '../Button/buttonsGetLine';

export default (container = document) => {
  $('[data-rte-external-pods]', container).each((i, pods) => {
    const $pods = $(pods);

    // weird things happen when you use the same format as shopify...
    const possibly_json = $pods.find('[data-settings]').html();
    const json = possibly_json.replace('// <![CDATA[', '').replace('// ]]>', '');
    const data = JSON.parse(json);
    const {blocks, settings} = data;
    let pods_content = '';
    let pod_animation = '';
    let pods_animation = '';

    if (settings.animation && settings.animation !== 'none') {
      pod_animation = `AnimateOnLoad Animate--${settings.animation}`;
      pods_animation = `Animate Animate--${settings.animation}`;
    }

    _.forEach(blocks, (pod) => {
      let pod_buttons = '';
      let pod_image = pod.image;
      let pod_alt = pod.heading;

      if (pod.image.url) {
        pod_image = pod.image.url;
      }

      if (pod.image.alt) {
        pod_alt = pod.image.alt;
      }

      _.forEach([1, 2, 3], (num) => {
        const button_text = `button_text_${num}`;
        const button_style = `button_style_${num}`;
        const button_url = `button_url_${num}`;
        const button_size = `button_size_${num}`;

        if (pod[button_text]) {
          pod_buttons += `
            <div class="Pod__button">
              <a href="${pod[button_url] || ''}" class="Button Button--${pod[button_style] || ''} Button--${pod[button_size] || ''}">
                ${pod[button_text] || ''}
              </a>
            </div>
          `;
        }
      });

      pods_content += `
        <div class="Pod Pod--external ${pod_animation}">
        <a href="${pod.button_url_1 || ''}">
          <div class="Pod__image ${pod.padded ? ' Pod__image--padded' : ''}">
            <img src="${pod_image || ''}" alt="${pod_alt || ''}" onLoad="elementLoaded(this);">     
          </div>
        </a>
        <div class="Pod__content">
          ${pod.heading ? `<a href="${pod.button_url_1 || ''}"><h3 class="Pod__heading">${pod.heading || ''}</h3></a>` : ''}
          ${pod['sub-heading'] ? `<p class="Pod__sub-heading">${pod['sub-heading'] || ''}</p>` : ''}
          ${pod.description ? `<p class="Pod__description">${pod.description || ''}</p>` : ''}
          ${pod_buttons}
        </div>
      </div>
      `;
    });

    const section_id = `RteExtenalPods--${i}`;
    const pods_style = `
      <style>
        .rte #section${section_id} .Section__container {
          padding-top: ${settings.padding_top || 50}px;
          padding-bottom: ${settings.padding_bottom || 50}px;
        }
        @media only screen and (max-width: ${window.theme.settings.grid_mobile_max}) {
          .rte #section${section_id} .Section__container {
            padding-top: ${settings['padding_top--mobile'] || 50}px;
            padding-bottom: ${settings['padding_bottom--mobile'] || 50}px;
          }      
        }    
        @media only screen and (max-width: ${window.theme.settings.grid_mobile_max}) {
          .rte #section${section_id} .Pod {
            padding-top: ${settings['vertical_spacing--mobile' || 30]}px;
            padding-bottom: ${settings['vertical_spacing--mobile' || 30]}px; 
          }
        }
      </style>
    `;

    const pods_section = `
      <section 
        id="section${section_id}" 
        data-section-id="${section_id}" 
        data-section-type="INF-Pods" 
        class="Section Section--${settings.width || 'fixed'} Section--${settings['width--mobile'] || 'mobile-fixed'}" 
        style="${settings.use_background ? `background: ${settings.background};` : ''}">

        <div class="Section__container ${pods_animation}">
          ${settings.preheading ? `<div class="Section__preheading angled-eyebrow">${settings.preheading}</div>` : ''}
          ${settings.heading ? `<h3 class="Section__heading">${settings.heading}</h3>` : ''}
          <div class="Pods ${settings.gutters ? '' : 'Pods--no-gutters'}">
            ${pods_content}
          </div>
        </div>
      </section>
      ${pods_style}
    `;
    
    $pods.html(pods_section);
    buttonsGetLine();
  });
};